import React, { createContext, useContext, useEffect, useState } from "react";
import { decryptDataFun } from "../utils/storage";

/** 🎯 User Context **/
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [module, setModule] = useState([]);
  const [selectCompany, setSelctedCompany] = useState(null);

  useEffect(() => {
    let storedUser = localStorage.getItem("user");
    if (storedUser) storedUser = decryptDataFun(storedUser);
    const storedModule = localStorage.getItem("module");
    if (storedUser) {
      setUser(storedUser);
      setModule(storedModule);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        module,
        setModule,
        selectCompany,
        setSelctedCompany,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export const useUser = () => useContext(AuthContext);
